import {ParamsSearchRequest, FilterCategories} from "../services/api/stores";

const localitiesConf: woosmap.localities.AutocompleteParameters = {
    minLength: 0,
    data: 'advanced',
    types: ['locality', 'postal_code', 'address', 'admin_level', 'airport', 'train_station', 'metro_station', 'shopping', 'country'],
    components: {
        country: ["fr"]
    },
};
const searchAPIParameters: ParamsSearchRequest = {
    stores_by_page: 7,
    radius: 500000
};
const availableServices: Array<FilterCategories> = [
    {
        category: "Sports",
        items: [
            {serviceKey: 'AR'},
            {serviceKey: 'ARG'},
            {serviceKey: 'ARS'},
            {serviceKey: 'ATH'},
            {serviceKey: 'BDM'},
            {serviceKey: 'BKB'},
            {serviceKey: 'BK3'},
            {serviceKey: 'BV'},
            {serviceKey: 'BOX'},
            {serviceKey: 'BKG'},
            {serviceKey: 'CSP'},
            {serviceKey: 'BMF'},
            {serviceKey: 'BMX'},
            {serviceKey: 'MTB'},
            {serviceKey: 'CSL'},
            {serviceKey: 'CRD'},
            {serviceKey: 'CTR'},
            {serviceKey: 'DIV'},
            {serviceKey: 'EQU'},
            {serviceKey: 'FEN'},
            {serviceKey: 'FB'},
            {serviceKey: 'GLF'},
            {serviceKey: 'HBL'},
            {serviceKey: 'HOC'},
            {serviceKey: 'JUD'},
            {serviceKey: 'OWS'},
            {serviceKey: 'MPN'},
            {serviceKey: 'GRY'},
            {serviceKey: 'ROW'},
            {serviceKey: 'RU7'},
            {serviceKey: 'SAL'},
            {serviceKey: 'SHO'},
            {serviceKey: 'SKB'},
            {serviceKey: 'CLB'},
            {serviceKey: 'SRF'},
            {serviceKey: 'SWM'},
            {serviceKey: 'TTE'},
            {serviceKey: 'TKW'},
            {serviceKey: 'TEN'},
            {serviceKey: 'GTR'},
            {serviceKey: 'TRI'},
            {serviceKey: 'VVO'},
            {serviceKey: 'WPO'},
            {serviceKey: 'WLF'},
            {serviceKey: 'WRE'},
        ]
    },
    // {
    //     category: "Gender",
    //     items: [
    //         {serviceKey: 'M'},
    //         {serviceKey: 'W'},
    //         {serviceKey: 'MX'}
    //     ]
    // }
]
export default {
    availableServices: availableServices,
    searchAPIParameters: searchAPIParameters,
    localitiesConf: localitiesConf
}
